/**
 * @voltxampere/ui — 7486 quad XOR TTL variant (Sprint 41-4)
 *
 * Reference: TI SN5486. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7486 = {
    id: "7486",
    nameTr: "7486 (4'lü XOR, DIP-14)",
    nameEn: "7486 (Quad XOR, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7486",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "XOR",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7486.js.map